import React from 'react';

type ToggleOptions = {
  label: string;
  value: string;
};

type PillToggleProps = {
  options: ToggleOptions[];
  selected: string;
  onChange: (val: string) => void;
};

const PillToggle: React.FC<PillToggleProps> = ({ selected, onChange }) => (
  <div className="pt-2 pb-2">
    <div className="flex bg-gray-100 rounded-lg w-fit p-1">
      <button
        type="button"
        className={`px-6 py-2 rounded-lg font-medium transition-colors
        ${selected === 'daily' ? 'bg-ow-blue text-white' : 'text-black cursor-pointer'}
      `}
        onClick={() => selected !== 'daily' && onChange('daily')}
        style={{ cursor: selected === 'daily' ? 'default' : 'pointer' }}
        disabled={selected === 'daily'}
      >
        Daily
      </button>
      <button
        type="button"
        className={`px-6 py-2 rounded-lg font-medium transition-colors
        ${selected === 'weekly' ? 'bg-ow-blue text-white' : 'text-black cursor-pointer'}
      `}
        onClick={() => selected !== 'weekly' && onChange('weekly')}
        style={{ cursor: selected === 'weekly' ? 'default' : 'pointer' }}
        disabled={selected === 'weekly'}
      >
        Weekly
      </button>
    </div>
  </div>
);

export default PillToggle;
